<div class="sggs-modal-wrapper">
    <div class="sggs-modal-header">
        <button mat-stroked-button mat-dialog-close>X</button>
    </div>
    <div class="sggs-modal-content">
        <iframe width="560" height="315" [src]="safeURL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
    <div class="sggs-modal-footer">

    </div>
</div>